import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes, { InferProps } from 'prop-types';

import classnames from 'classnames/bind';

import useScrollLock from '@HOOKS/useScrollLock';

import SearchInput from '@COMPONENTS/COMMON/inputs/input/SearchInput';

import styles from './ResultSetWrapper.module.scss';

const cx: CX = classnames.bind(styles);

function ResultSetWrapper(props: Props) {
    const {
        setFocused,
        children,
        searchValue,
        onSearchChange,
        isSearchLoading,
        searchPlaceholder,
    } = props;

    const { lock, unlock } = useScrollLock();

    useEffect(() => {
        lock();

        return () => {
            unlock();
        };
    }, [lock, unlock]);

    const modalContent = (
        <div className={cx('modal-overlay')}>
            {/* Background overlay */}
            <div
                className={cx('backdrop')}
                onClick={() => setFocused(false)}
                role="button"
                tabIndex={0}
                aria-label="Close search"
            />
            
            {/* Modal content */}
            <div className={cx('modal-container')}>
                {/* Header with search */}
                <div className={cx('modal-header')}>
                    <div className={cx('search-section')}>
                        <SearchInput
                            isLoading={isSearchLoading}
                            placeholder={searchPlaceholder}
                            value={searchValue}
                            onChange={onSearchChange}
                            onFocus={() => {}}
                            hideClearIcon={false}
                        />
                    </div>
                    
                    <button
                        type="button"
                        className={cx('close-button')}
                        onClick={() => setFocused(false)}
                        aria-label="Close search"
                    >
                        ×
                    </button>
                </div>

                {/* Results content */}
                <div className={cx('modal-body')}>
                    {children}
                </div>
            </div>
        </div>
    );

    // Render the modal using React Portal at the document body level
    return ReactDOM.createPortal(
        modalContent,
        document.body
    );
}

ResultSetWrapper.propTypes = {
    setFocused: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    onSearchChange: PropTypes.func.isRequired,
    isSearchLoading: PropTypes.bool.isRequired,
    searchPlaceholder: PropTypes.string.isRequired,
};

type Props = InferProps<typeof ResultSetWrapper.propTypes> & OnlyChildrenProps;

export default ResultSetWrapper;
